import React, { useState, ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { getDurationTo } from '~/helpers/time';
import { timeDiff as timeDiffSelector } from '~/App/shared/selectors/global';
import { useInterval } from '../hooks/useIntervalHook';
import { useStableNow } from '~/App/shared/hooks/useStableNow';

interface P {
  closeAt: Date;
}

export interface Props {
  minutes: number;
  seconds: number;
}

const intervalDelay = 1000;

const withTimer =
  (WrappedComponent: ComponentType<Props>): ComponentType<P> =>
  (props: P) => {
    const timeDiff = useSelector(timeDiffSelector);
    const stableNow = useStableNow();

    const [seconds, setSeconds] = useState(() => {
      const s = getDurationTo(
        timeDiff,
        props.closeAt,
        new Date(stableNow)
      ).seconds();
      return s < 0 ? 0 : s;
    });
    const [minutes, setMinutes] = useState(() => {
      const m = getDurationTo(
        timeDiff,
        props.closeAt,
        new Date(stableNow)
      ).minutes();
      return m < 0 ? 0 : m;
    });

    useInterval(() => {
      const duration = getDurationTo(timeDiff, props.closeAt);

      let minutes = duration.minutes();
      let seconds = duration.seconds();

      if (minutes < 0) {
        minutes = 0;
      }

      if (seconds < 0) {
        seconds = 0;
      }

      setSeconds(seconds);
      setMinutes(minutes);
    }, intervalDelay);

    return <WrappedComponent minutes={minutes} seconds={seconds} />;
  };

export default (c: ComponentType<Props>) => withTimer(c);
